import {Controller} from 'stimulus'

export default class extends Controller {
  static targets = ['role', 'fundingSource']

  connect () {
    this.update()
  }

  update () {
    if (!this.hasFundingSourceTarget) return

    const isFundingPartner = this.roleTarget.value === 'donor'
    this.fundingSourceTarget.style.display = isFundingPartner ? '' : 'none'

    // Left submittable rather than disabled, so moving a user off the Funding
    // Partner role clears the source they no longer have.
    if (!isFundingPartner) this.fundingSourceTarget.querySelector('select').value = ''
  }
}
